jQuery(document).on("click", ".slider-nav-links__item button", function()
{
  let clickedButton = jQuery(this);
  if (clickedButton.hasClass("active"))
  {
    return false;
  }

  let activeButtonIndex = parseInt(clickedButton.closest(".slider-nav-links").find(".slider-nav-links__item.active button").attr("data-slide-index"));
  let newIndex = parseInt(clickedButton.attr("data-slide-index"));
  clickedButton.closest(".slider-nav-links").find(".slider-nav-links__item").removeClass("from-next from-prev");
  if (activeButtonIndex > newIndex)
  {
    clickedButton.parent().addClass("from-next");
  }
  else
  {
    clickedButton.parent().addClass("from-prev");
  }
  
  clickedButton.closest(".slider-nav-links").find(".slider-nav-links__item.active").removeClass("active");
  clickedButton.parent().addClass("active");

  
  jQuery(".testimonial-slider-track").css("translate", "calc(" + newIndex + " * (-100% - 50px)) 0");
  
});